import { AdminShipmentWithLatestStatusModel } from "../apiModels/adminShipmentWithLatestStatusModel";
import { ApplicationUserPending } from "../apiModels/applicationUserPending";
import { QuoteRequestResponse } from "../apiModels/quoteRequestResponse";
import { ShipmentCreateModel } from "../apiModels/shipmentCreateModel";
import { ShipmentEditModel } from "../apiModels/shipmentEditModel";
import apiPaths from "./apiPaths";
import { del, get, post, put } from "./apiUtilities";

export const getPendingUserAccounts = async () => await get<ApplicationUserPending[]>(apiPaths.getPendingUserAccounts);

export const approvePendingUserAccount = async (id: string) => await post(`${apiPaths.approvePendingUserAccount}/${id}`);

export const deletePendingUserAccount = async (id: string) => await del(`${apiPaths.deletePendingUserAccount}/${id}`);

export const getQuoteRequestPage = async (page: number, count: number) => await get<QuoteRequestResponse[]>(`${apiPaths.getQuoteRequestPage}/${page}/${count}`);

export const dismissQuoteRequest = async (quoteRequestId: number) => await put(`${apiPaths.dismissQuoteRequest}/${quoteRequestId}`);

export const getDismissedQuoteRequestPage = async (page: number, count: number) => await get<QuoteRequestResponse[]>(`${apiPaths.getDismissedQuoteRequestPage}/${page}/${count}`);

export const createShipment = async (shipment: ShipmentCreateModel) => await post(apiPaths.createShipment, {
    body: JSON.stringify(shipment)
});

export const editShipment = async (trackingNumber: string, shipment: ShipmentEditModel) => await put(`${apiPaths.editShipment}/${trackingNumber}`, {
    body: JSON.stringify(shipment)
});

export const getActiveShipmentsWithLatestStatus = async (page: number, count: number) => 
    await get<AdminShipmentWithLatestStatusModel[]>(`${apiPaths.getActiveShipmentsWithLatestStatus}/${page}/${count}`);

export const getCompletedShipmentsWithLatestStatus = async (page: number, count: number) => 
    await get<AdminShipmentWithLatestStatusModel[]>(`${apiPaths.getCompletedShipmentsWithLatestStatus}/${page}/${count}`);

export const getShipmentWithLatestStatus = async (trackingNumber: string) => 
    await get<AdminShipmentWithLatestStatusModel>(`${apiPaths.getShipment}/${trackingNumber}`);

export const getShipment = async (trackingNumber: string) => 
    await get<AdminShipmentWithLatestStatusModel>(`${apiPaths.getShipment}/${trackingNumber}`);